"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.triggerBroadcast = triggerBroadcast;
var _context = require("../context");
var _sendMessage = require("../send-message");
/*
* Copyright (c) 2020 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/

/**
 * Trigger Broadcast Handler
 * - Handles a request for broadcast by the SDK by returning a list of other SDK iframes
 *
 * @module core-bootstrap-trigger-broadcast-handler
 */

/**
 * Trigger a broadcast
 *
 * @param {*} data Data containing SDK frame information
 * @return {*} message payload data, if available, null otherwise
 */
function triggerBroadcast(data) {
  var fromFrameID = data.fromFrameID;
  var iframeEntry = (0, _context.getIframeConfiguration)(fromFrameID);
  if (!iframeEntry) {
    return null;
  }
  var allIframes = (0, _context.getContext)().iframes.map(function (iframeEntry) {
    return {
      id: iframeEntry.id,
      nonce: iframeEntry.nonce,
      targetOrigin: (0, _context.getContext)().iframeTargetOrigin
    };
  });
  var otherIframes = allIframes.filter(function (iframe) {
    return iframe.id !== fromFrameID;
  });
  data.otherIframes = otherIframes;
  (0, _sendMessage.sendMessage)('broadcast', data, fromFrameID);
  return data;
}
//# sourceMappingURL=trigger-broadcast.js.map